// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"281":"newcar","471":"activity","535":"login","759":"carDetail","826":"index","942":"article","979":"oldcar"}[chunkId] + "." + {"281":"679a7669","471":"b312bf6c","535":"fe5c07e6","759":"6d338d70","826":"cc119ed9","942":"d2dedb27","979":"b7573f25"}[chunkId] + ".js";
};